import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "m-checkout-button-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MButton = _resolveComponent("MButton")!

  return (_ctx.getters.walletConnected)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_MButton, {
          appearance: "primary",
          type: "button",
          "button-class": "m-checkout-button",
          "is-loading": _ctx.isCheckingOut,
          disabled: _ctx.disabled,
          onClick: _ctx.checkoutCart
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.buttonText), 1)
          ]),
          _: 1
        }, 8, ["is-loading", "disabled", "onClick"]),
        _createVNode(_component_MButton, {
          appearance: "secondary",
          type: "button",
          "button-class": "m-checkout-button-clear-cart",
          "is-loading": _ctx.isClearingCart,
          disabled: _ctx.disabled,
          onClick: _ctx.clearCart
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.clearCartTextFn), 1)
          ]),
          _: 1
        }, 8, ["is-loading", "disabled", "onClick"])
      ]))
    : _createCommentVNode("", true)
}